// Fixed bar docked above the mobile bottom nav (and to the bottom on desktop)
export const DockBar = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="fixed inset-x-0 bottom-[calc(var(--nav-h)+env(safe-area-inset-bottom))] z-30 lg:bottom-0 lg:left-64"
  >
    <div className="mx-auto max-w-5xl px-3 pb-3 sm:px-8 lg:pb-6">{children}</div>
  </div>
);

export const PageHeader = ({ eyebrow, title, aside }) => (
  <div className="rise mb-8 flex items-end justify-between gap-4">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="text-3xl tracking-tight text-ivory sm:text-4xl lg:text-5xl">{title}</h1>
    </div>
    {aside}
  </div>
);

export const Section = ({ title, aside, children, className = "" }) => (
  <section className={`rise ${className}`}>
    <div className="mb-4 flex items-baseline justify-between gap-3">
      <h2 className="text-xl tracking-tight text-ivory">{title}</h2>
      {aside}
    </div>
    {children}
  </section>
);
